import { CdkScrollable } from '@angular/cdk/scrolling';
import { Component, OnInit, inject } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButton } from '@angular/material/button';
import { MatCard } from '@angular/material/card';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogTitle, MatDialogContent, MatDialogActions } from '@angular/material/dialog';
import { MatLabel, MatFormField } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { SettingsService } from '@service/settings.service';

@Component({
  selector: 'app-share-link-dialog',
  templateUrl: './share-link-dialog.component.html',
  styleUrls: ['./share-link-dialog.component.scss'],
  imports: [
    MatCard,
    MatDialogTitle,
    CdkScrollable,
    MatDialogContent,
    MatLabel,
    FormsModule,
    ReactiveFormsModule,
    MatFormField,
    MatInput,
    MatDialogActions,
    MatButton,
  ],
})
export class ShareLinkDialogComponent implements OnInit {
  dialogRef = inject<MatDialogRef<ShareLinkDialogComponent>>(MatDialogRef);
  private formBuilder = inject(FormBuilder);
  private settingsService = inject(SettingsService);
  data = inject<{
    shareLink: string;
    fileId: string;
    identifier: string;
    ipType: string;
}>(MAT_DIALOG_DATA);

  shareLinkForm!: FormGroup;

  constructor() {
    const baseUrl = this.settingsService.getParsedBaseUrl();
    const { ipType } = this.data;
    this.data.shareLink = `${baseUrl}index.jsp?redirectDocument=${this.data.fileId!}&type=${ipType === 'Patent' ? 'Case' : ipType}&redirectDocumentCase=${encodeURIComponent(this.data.identifier)}&openDoc=Y`;
  }

  ngOnInit(): void {
    this.shareLinkForm = this.formBuilder.group({
      shareLinkInput: [this.data.shareLink],
    });
  }
}
